/**
 * Audio Controller Class
 *
 * Handles the audio components
 *
 * Can be called by example: musicManager.onFreespinsIntro();
 *
 */
musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.inBaseGameModifier = false;
musicManager.inBigWin = false;
musicManager.musicLevel = 1;
musicManager.maxMusicVolume = 0.6;

musicManager.ALLOFFLEVEL = [false, false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false, false];
musicManager.SINGLEWINLEVEL = [false, false, true, false, false];
musicManager.MULTIWINLEVEL = [false, false, true, false, false];
musicManager.REALLYBIGWINLEVEL = [false, false, true, false, false];
musicManager.ANTICIPATIONLEVEL = [false, false, false, true, false];
musicManager.GAMBLELEVEL = [false, false, false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false, false];
musicManager.FREESPINS_BASE = [true, false, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false, false];
musicManager.FREESPINS_ANTICIPATIONLEVEL = [false, false, true, false];
musicManager.FREESPINS_INTROLEVEL = [false, false, false, true];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.fadeInActive = false;
musicManager.fadeOutActive = false;

musicManager.fadeInTimer = undefined;
musicManager.fadeOutTimer = undefined;

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

musicManager.fadeInActiveFS = false;
musicManager.fadeOutActiveFS = false;

musicManager.fadeInTimerFS = undefined;
musicManager.fadeOutTimerFS = undefined;

musicManager.currentBaseLevels = undefined;
musicManager.currentFSLevels = undefined;

musicManager.returnTimer = undefined;
musicManager.returnDelayTime = 8;

musicManager.returnIdleTimer = undefined;
musicManager.returnIdleTime = 1.5;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 1000;
  musicManager.fadeBaseTimeOut = 2000;

  musicManager.fadeLevelTimeIn = 1500;
  musicManager.fadeLevelTimeOut = 2000;

  musicManager.fadeGambleTimeIn = 1000;
  musicManager.fadeGambleTimeOut = 1000;

  musicManager.fadeBigWinTimeIn = 1000;
  musicManager.fadeBigWinTimeOut = 1000;

  musicManager.fadeSymWinTimeIn = 300;
  musicManager.fadeSymWinTimeOut = 300;

  musicManager.baseMusic = ['bgBGTheme0', 'bgBGTheme1', 'bgBGTheme2', 'bsAnticipation', 'gambleLoop'];

  musicManager.basePlaying = [false, false, false, false, false];

  musicManager.baseID = [];

  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = ['freeSpinsLoop0', 'freeSpinsLoop1', 'fsAnticipation', 'freeSpinsIntroLoop'];

  musicManager.fsPlaying = [false, false, false, false];

  musicManager.freeSpinsID = [];
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.fadeLevels(musicManager.IDLELEVEL, 0, 0, 1, 0);
};

// musicManager.onSymbolWinlineStart = function () {
//   if (musicManager.inFreespins) {
//     musicManager.previouslyPlayingBeforeFade = musicManager.fsPlaying;
//     musicManager.fadeFSLevels(
//       musicManager.FREESPINS_ALLOFF,
//       musicManager.fadeSymWinTimeIn,
//       musicManager.fadeSymWinTimeOut,
//       1,
//       0.3
//     );
//   } else {
//     musicManager.previouslyPlayingBeforeFade = musicManager.basePlaying;
//     musicManager.fadeLevels(
//       musicManager.ALLOFFLEVEL,
//       musicManager.fadeSymWinTimeIn,
//       musicManager.fadeSymWinTimeOut,
//       1,
//       0.3
//     );
//   }
// };

musicManager.onSymbolWinlineEnd = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeIOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut,
      1,
      0.3
    );
  }
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameStart = function () {
  musicManager.idle = false;
  musicManager.stepDownTimer = undefined;
  if (!musicManager.playing && !musicManager.inFreespins) {
    musicManager.playing = true;
    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut, 1, 0);
  }
};

musicManager.onGameEnd = function (fromGamble = false) {
  musicManager.idle = true;
  musicManager.playing = false;
  if (!autoplayManager.isAutoplayEnabled() || autoplayManager.getRemainingRounds() <= 0) {
    const timerDuration = fromGamble ? musicManager.returnIdleTime / 2 : musicManager.returnIdleTime;
    musicManager.returnIdleTimer = gsap.delayedCall(timerDuration, () => {
      if (musicManager.idle === true) {
        musicManager.fadeLevels(
          musicManager.IDLELEVEL, //
          musicManager.fadeBaseTimeIn,
          musicManager.fadeBaseTimeOut,
          1,
          0
        );
      }
    });
  }
};

// this isnt being used anywhere from dead lucky from what i can see
// im going to leave here for future!!
musicManager.stepDown = function () {
  if (musicManager.basePlaying === musicManager.REALLYBIGWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);

    musicManager.fadeLevels(
      musicManager.MULTIWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);

    musicManager.fadeLevels(
      musicManager.SINGLEWINLEVEL,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut,
      1,
      0
    );
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(4000, undefined, musicManager.stepDown);

    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut, 1, 0);
  } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    timerManager.stop(musicManager.stepDownTimer);

    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut, 1, 0);
  }
};

musicManager.playGambleLoop = function () {
  musicManager.fadeLevels(
    musicManager.GAMBLELEVEL,
    musicManager.fadeGambleTimeIn,
    musicManager.fadeGambleTimeOut,
    1,
    0
  );
};

musicManager.stopGambleLoop = function () {
  musicManager.onGameEnd(true);
  // musicManager.fadeLevels(
  //   musicManager.IDLELEVEL, //
  //   musicManager.fadeGambleTimeIn,
  //   musicManager.fadeGambleTimeOut,
  //   1,
  //   0
  // );
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play('bigWinLoop');

  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    // /musicManager.stepDownTimer  = timerManager.addTimer(4000, undefined , musicManager.stepDown);
    musicManager.fadeLevels(
      musicManager.ALLOFFLEVEL,
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut,
      1,
      0
    );
  }
};

musicManager.stopBigWin = function () {
  soundManager.stop('bigWinLoop');
};

musicManager.playBigWinEnd = function () {
  soundManager.play('bigWinEnd');
};

musicManager.stopBigWinEnd = function (level = musicManager.IDLELEVEL) {
  // ideally start the music as it was
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      level, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut
    );
  } else {
    // go back to the track we had before - but - what if we are then going to the gamble?
    // but we dont know if we are going to the gamble just yet
    // thats all done from 'spinner:GambleDataEvent'
    musicManager.fadeLevels(
      level, //
      musicManager.fadeBigWinTimeIn,
      musicManager.fadeBigWinTimeOut,
      1,
      0
    );
  }
};

musicManager.fadeBigWin = function (newVolume) {
  soundManager.setVolume(newVolume, musicManager.bigWinID);
};

// Sets a prolong delay to return.
musicManager.restartReturnTimer = function () {
  if (musicManager.returnTimer) musicManager.returnTimer.restart();
};

/////////////////////////////////
// Pass in 5 item array - with levels that need to be on and off )
// e.g. F,F,T,T,F will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime, volIn, volOut) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  console.log('fadeLevels to ' + musicManager.levelsToName(levels), levels);
  if (musicManager.currentBaseLevels === levels) {
    // duplicate request for same level
    // should ignore
    console.log('fadeLevels already playing ' + musicManager.levelsToName(levels));
    return;
  }

  musicManager.previousBaseLevels = musicManager.currentBaseLevels;

  musicManager.currentBaseLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeLevelsOutFinished(volOut);
  }

  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  musicManager.fadeInActive = false;
  musicManager.fadeOutActive = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
      musicManager.fadeInActive = true;
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
      musicManager.fadeOutActive = true;
    }
  }

  musicManager.fadeInTimer = timerManager.addTimer(
    fadeInTime, //
    musicManager.fadeLevelsIn,
    () => {
      musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
    }
  );
  musicManager.fadeOutTimer = timerManager.addTimer(
    fadeOutTime, //
    musicManager.fadeLevelsOut,
    () => {
      musicManager.fadeLevelsOutFinished(volOut);
    }
  );

  musicManager.basePlaying = levels;
};

musicManager.levelsToName = function (levels) {
  let name = 'musicManager.ALLOFFLEVEL';
  if (levels === musicManager.IDLELEVEL) {
    name = 'musicManager.IDLELEVEL';
  } else if (levels === musicManager.SPINLEVEL) {
    name = 'musicManager.SPINLEVEL';
  } else if (levels === musicManager.SINGLEWINLEVEL) {
    name = 'musicManager.SINGLEWINLEVEL';
  } else if (levels === musicManager.MULTIWINLEVEL) {
    name = 'musicManager.MULTIWINLEVEL';
  } else if (levels === musicManager.REALLYBIGWINLEVEL) {
    name = 'musicManager.REALLYBIGWINLEVEL';
  } else if (levels === musicManager.ANTICIPATIONLEVEL) {
    name = 'musicManager.ANTICIPATIONLEVEL';
  } else if (levels === musicManager.GAMBLELEVEL) {
    name = 'musicManager.GAMBLELEVEL';
  }

  return name;
};

musicManager.fsLevelsToName = function (levels) {
  let name = 'musicManager.FREESPINS_ALLOFF';
  if (levels === musicManager.FREESPINS_BASE) {
    name = 'musicManager.FREESPINS_BASE';
  } else if (levels === musicManager.FREESPINS_LEVEL1) {
    name = 'musicManager.FREESPINS_LEVEL1';
  } else if (levels === musicManager.FREESPINS_ANTICIPATIONLEVEL) {
    name = 'musicManager.FREESPINS_ANTICIPATIONLEVEL';
  } else if (levels === musicManager.FREESPINS_INTROLEVEL) {
    name = 'musicManager.FREESPINS_INTROLEVEL';
  }
  return name;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  // we must immediately jump to the end if we are fading in/out and another request comes in
  // stop doesn't call the finished call backs so do them manually here
  console.log('fadeFSLevels to ' + musicManager.fsLevelsToName(levels), levels);
  if (levels == musicManager.currentFSLevels) {
    console.log('fadeFSLevels already playing ' + musicManager.fsLevelsToName(levels));
    return;
  }

  musicManager.previousFSLevels = musicManager.currentFSLevels;

  musicManager.freeSpinsLevel = levels;
  musicManager.currentFSLevels = levels;

  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeLevelsInFinishedFS();
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeLevelsOutFinishedFS();
  }

  // at end as we may not have a channel currently playing - musicManager.fsPlaying = levels;
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  musicManager.fadeInActiveFS = false;
  musicManager.fadeOutActiveFS = false;

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeInActiveFS = true;
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
      musicManager.fadeOutActiveFS = true;
    }
  }

  if (musicManager.fsPlaying[2] === true && !gameController.getIsIdle()) {
    // resourceManager.get("GuitaristView").stopEdsAudioSetter(true);
    // resourceManager.get("GuitaristView").playGuitarist();
  }

  musicManager.fadeInTimerFS = timerManager.addTimer(
    fadeInTime,
    musicManager.fadeLevelsInFS,
    musicManager.fadeLevelsInFinishedFS
  );
  musicManager.fadeOutTimerFS = timerManager.addTimer(
    fadeOutTime,
    musicManager.fadeLevelsOutFS,
    musicManager.fadeLevelsOutFinishedFS
  );

  musicManager.fsPlaying = levels;
};

// BASE VERSIONS

musicManager.fadeLevelsIn = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(progress * musicManager.maxMusicVolume, musicManager.soundsToFadeIn[i]);
  }
};

musicManager.fadeLevelsOut = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOut[i]
    );
  }
};

musicManager.fadeLevelsInFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeIn[i]);
  }
  musicManager.fadeInActive = false;
};

musicManager.fadeLevelsOutFinished = function (volume) {
  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.setVolume(volume, musicManager.soundsToFadeOut[i]);
  }

  musicManager.fadeOutActive = false;
};

// FREESPIN VERSIONS
musicManager.fadeLevelsInFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(progress * musicManager.maxMusicVolume, musicManager.soundsToFadeInFS[i]);
  }
};

musicManager.fadeLevelsOutFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(
      musicManager.maxMusicVolume - progress * musicManager.maxMusicVolume,
      musicManager.soundsToFadeOutFS[i]
    );
  }
};

musicManager.fadeLevelsInFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.setVolume(musicManager.maxMusicVolume, musicManager.soundsToFadeInFS[i]);
  }

  musicManager.fadeInActiveFS = false;
};

musicManager.fadeLevelsOutFinishedFS = function (progress) {
  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.setVolume(0, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fadeOutActiveFS = false;
};

musicManager.restartBaseMusic = function () {
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut, 1, 0);
};

musicManager.restartFreeSpins = function () {
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onFreespinsIntroTransition = async function () {
  // timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut, 1, 0);
  musicManager.playing = false;
  soundManager.play('freeSpinsIntroTransition');
  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.onFreespinsOutroTransition = async function () {
  // timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeFSLevels(
    musicManager.FREESPINS_ALLOFF, //
    musicManager.fadeLevelTimeIn,
    musicManager.fadeLevelTimeOut
  );
  musicManager.inFreespins = false;
  musicManager.playing = false;
  soundManager.play('freeSpinsOutroTransition');
  musicManager.playing = true;
};

musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === 'back from replay' && !Reflex.replayGame) {
    musicManager.basePlaying = [false, false, false, false, false];
    musicManager.baseID = [];
    musicManager.fsPlaying = [false, false, false, false];
    musicManager.freeSpinsID = [];
    musicManager.soundsToFadeIn = [];
    musicManager.currentBaseLevels = undefined;
    musicManager.currentFSLevels = undefined;
    musicManager.onGameLoaded();
    musicManager.fadeLevelsInFinished(musicManager.maxMusicVolume);
    musicManager.stopAllTimers();
    musicManager.soundsToFadeOut = [];
    musicManager.soundsToFadeIn = [];
    musicManager.soundsToFadeOutFS = [];
    musicManager.soundsToFadeInFS = [];
  }
};

musicManager.stopAllTimers = function () {
  if (musicManager.returnIdleTimer) {
    musicManager.returnIdleTimer.kill();
    musicManager.returnIdleTimer = undefined;
  }

  if (musicManager.returnTimer) {
    musicManager.returnTimer.kill();
    musicManager.returnTimer = undefined;
  }

  if (musicManager.fadeInActive) {
    timerManager.stop(musicManager.fadeInTimer);
    musicManager.fadeInActive = false;
  }

  if (musicManager.fadeOutActive) {
    timerManager.stop(musicManager.fadeOutTimer);
    musicManager.fadeOutActive = false;
  }

  if (musicManager.fadeInActiveFS) {
    timerManager.stop(musicManager.fadeInTimerFS);
    musicManager.fadeInActiveFS = false;
  }

  if (musicManager.fadeOutActiveFS) {
    timerManager.stop(musicManager.fadeOutTimerFS);
    musicManager.fadeOutActiveFS = false;
  }
};

musicManager.onGoingToReplay = function () {
  // we may have some of our own tweens still running ffs
  musicManager.stopAllTimers();
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);

messageBus.subscribe('sounds:restorePreviouslyPlayingAudio', musicManager.onRestorePreviouslyPlayingAudio);
messageBus.subscribe('game:goingToReplay', musicManager.onGoingToReplay);
